import { createReducer, on } from '@ngrx/store';
import * as OnboardingActions from '../actions/updateOnboardingData.actions';

// Definimos la interfaz de lo que contiene cada cambio
export interface CambioFocunInterface {
  id: number;
  campo: string;
  valorAnterior: any;
  valorNuevo: any;
}

// Definimos el estado para este módulo
export interface OnboardingState {
  cambiosFocun: CambioFocunInterface[];
}

export const initialState: OnboardingState = {
  cambiosFocun: []
};

export const updateOnboardingDataReducer = createReducer(
  initialState,

  on(OnboardingActions.registrarCambioFocun, (state, { id, campo, valorAnterior, valorNuevo }) => {
    // 1. Buscamos si ya existe un cambio previo para este ID y Campo
    const existeCambio = state.cambiosFocun.find(
      item => item.id === id && item.campo === campo
    );

    let nuevaLista;

    if (existeCambio) {
      // 2. Si ya existe, actualizamos solo el valorNuevo de ese registro
      nuevaLista = state.cambiosFocun.map(item =>
        (item.id === id && item.campo === campo) 
          ? { ...item, valorNuevo } 
          : item
      );
    } else {
      // 3. Si es nuevo, lo agregamos a la lista
      nuevaLista = [...state.cambiosFocun, { id, campo, valorAnterior, valorNuevo }];
    }

    return {
      ...state,
      cambiosFocun: nuevaLista
    };
  }),

  // Acción para resetear la lista cuando termines el proceso
  on(OnboardingActions.limpiarCambiosFocun, (state) => ({
    ...state,
    cambiosFocun: []
  }))
);
